var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 266 266",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "path6212",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.755,
    y: 684.986,
    width: 79.906,
    height: 79.906,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6214",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.12,690.58L339.069,690.58L339.069,734.529L295.12,690.58",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6216",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.573,755.359L275.103,755.359C276.329,755.359 278.4,755.42 278.4,753.666C278.4,751.742 276.349,751.932 274.996,751.932L274.573,751.932L274.573,755.359ZM274.573,748.845L275.039,748.845C276.139,748.845 277.28,748.656 277.28,747.304C277.28,745.845 275.989,745.759 274.87,745.759L274.573,745.759L274.573,748.845ZM270.429,758.529L270.429,742.589L276.349,742.589C279.183,742.589 281.085,743.686 281.085,746.731C281.085,748.17 280.62,749.332 279.33,749.987L279.33,750.03C281.614,750.326 282.586,751.87 282.586,754.09C282.586,757.43 279.733,758.529 276.814,758.529L270.429,758.529",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6218",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.106,747.515L291.065,747.515L289.353,752.587L292.798,752.587L291.106,747.515ZM288.21,755.76L287.111,758.529L282.714,758.529L288.845,742.589L293.369,742.589L299.374,758.529L294.954,758.529L293.918,755.76L288.21,755.76",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6220",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.495,742.589L313.495,751.552C313.495,753.602 313.41,755.632 311.825,757.176C310.493,758.487 308.399,758.951 306.539,758.951C304.679,758.951 302.585,758.487 301.254,757.176C299.668,755.632 299.583,753.602 299.583,751.552L299.583,742.589L303.728,742.589L303.728,750.981C303.728,753.052 303.875,755.316 306.539,755.316C309.203,755.316 309.351,753.052 309.351,750.981L309.351,742.589L313.495,742.589",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6222",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.091,746.099L320.091,748.761L324.763,748.761L324.763,752.271L320.091,752.271L320.091,755.019L325.016,755.019L325.016,758.529L315.946,758.529L315.946,742.589L325.016,742.589L325.016,746.099L320.091,746.099",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path6232",
    transform: "matrix(3.31684,0,0,3.31684,-878.149,-2271.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.55,749.734L331.951,749.734C333.305,749.734 334.828,749.481 334.828,747.746C334.828,746.012 333.305,745.759 331.951,745.759L331.55,745.759L331.55,749.734ZM340.661,758.529L335.504,758.529L331.591,752.397L331.55,752.397L331.55,758.529L327.406,758.529L327.406,742.589L333.601,742.589C336.751,742.589 339.14,744.089 339.14,747.492C339.14,749.692 337.914,751.595 335.651,751.996L340.661,758.529",
    style: {
      fill: "rgb(0,40,135)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0d981b0.svg";
export { ForwardRef as ReactComponent };